<div class="min-h-[calc(100vh-4.3rem)] relative">
  <div
    [ngClass]="{
      'pr-0 transition-all duration-300': !sidebarOpen && !isResizing,
      'transition-all duration-200': sidebarOpen && !isResizing,
    }"
    [style.padding-right.px]="sidebarOpen ? sidebarWidth : 0"
  >
    <div class="px-4 py-10 sm:px-6 lg:px-8 lg:py-6 relative h-[calc(100vh-4.3rem)] overflow-hidden @container">
      <p class="text-amazone-green ms-4 me-10 text-end">
        <strong>{{ getItemsTotalCount() }}</strong> NW Numbers
      </p>

      <app-nw-number-accordion
        [groupedNwNumbers]="groupedNwNumbers"
        (nwNumberClicked)="onNwNumberClicked($event)"
        (createNwNumberClicked)="onCreateNwNumber($event)"
        (projectClicked)="onProjectClicked($event)"
        (nwNumberImportClicked)="onNwNumberImport($event)"
        (projectImportClicked)="onProjectImport($event)"
        (nwNumberExportClicked)="onNwNumberExport($event)"
        (publishEventsClicked)="sendServiceBusEvents($event)"
      ></app-nw-number-accordion>
    </div>
  </div>
  @if (sidebarOpen) {
    <div
      class="right-0 fixed overflow-y-auto border-l border-gray-200 min-h-full top-[4rem]"
      [style.width.px]="sidebarWidth"
    >
      <div
        class="absolute left-0 top-0 w-1.5 h-full cursor-col-resize bg-transparent hover:bg-amazone-green hover:opacity-50 transition-colors duration-200"
        (mousedown)="startResize($event)"
      ></div>
      <app-sidebar
        (closeSidebarTriggered)="onClosingSidebar()"
        (updatedProject)="onUpdatedProject($event)"
        (updatedNwNumber)="handleNwNumberUpdated($event)"
        [detailsViewConfig]="nwNumberDetailConfiguration"
        [sideBarTitle]="sideBarTitle"
        [sidebarConfiguration]="sidebarConfiguration"
        [editComponentType]="currentEditComponentType"
        [editComponentId]="$safeNavigationMigration(selectedItem?.id)"
        [nwNumber]="nwNumber"
        [project]="project"
        [detailedLanguageTranslationStatesDocumentation]="aggregatedLanguageTranslationStatesDocumentation"
        [detailedLanguageTranslationStatesTerminal]="aggregatedLanguageTranslationStatesTerminal"
      ></app-sidebar>
    </div>
  }
</div>

<app-decision-modal
  #createNwNumberModal
  [header]="'Create new NW Number'"
  [details]="['Continue creating new NW Number ' + $safeNavigationMigration(this.newNwNumberToCreate?.number) + '?']"
  [yesNoButtons]="true"
  businessObject="nwNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleCreateNwNumberDecision($event)"
></app-decision-modal>

<app-decision-modal
  #proceedImportModal
  [header]="modalProceedImportHeader"
  [details]="modalProceedImportDetails"
  [yesNoButtons]="true"
  businessObject="nwNumber"
  [decisionLevel]="decisionLevel"
  (decision)="handleProceedImportDecision($event)"
></app-decision-modal>
